/**
 * useTax provides utility functions for working with tax rates.
*/
export function useTax() {
  /**
   * Calculate VAT amount
   * @param {number} input - The input value.
   * @returns {number} The calculated rate.
   */
  const getVATAmount = (input) => {
    if (isNaN(input)) {
      console.error('Invalid input. Please provide a valid number.');
      return 0;
    }

    const vatRate = process.env.MIX_VAT_RATE && process.env.MIX_VAT_RATE !== "${VAT_RATE}" ? parseFloat(process.env.MIX_VAT_RATE) : 0.2;
    return input * vatRate;
  };

  /**
   * Adds VAT to input
   * @param {number} input - The input value.
   * @returns {number} The total value.
   */
  const getPriceWithVAT = (input) => {
    if (isNaN(input)) {
      console.error('Invalid input. Please provide a valid number.');
      return input;
    }

    const rate = getVATAmount(input);
    return parseFloat(input) + rate;
  };

  return {
    getVATAmount,
    getPriceWithVAT,
  };
}
